import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganicFertilizerType } from '~/api/services/climaCheck'
import Dialog from '~/components/Dialog'
import { fertilizerDataFields } from './SecondStep'
import CustomInput from '~/components/CustomInput'

interface Props {
  handleClose: () => void
  fertilizerData: OrganicFertilizerType
  handleSubmit: (fertilizerData: OrganicFertilizerType, updateData) => void
}

const defaultValues = {
  dryMatter: '',
  organicMatter: '',
  n: '',
  nh4N: '',
  nLosses: '',
  p2o5: '',
  k2o: ''
}

const EditFertilizers:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { handleClose, fertilizerData, handleSubmit } = props

  const [fertilizerValues, setFertlizerValues] = useState(defaultValues)

  useEffect(() => {
    if(fertilizerData) {
      setFertlizerValues(fertilizerData)
    }
  }, [fertilizerData])

  function handleSubmitFertilizer() {
    setFertlizerValues(defaultValues)
    handleSubmit(fertilizerData, fertilizerValues)
  }

  function renderFertilizerValues() {
    return <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
      {fertilizerDataFields.map(fertilizerField => {
        return <CustomInput
          key={fertilizerField.key}
          value={fertilizerValues[fertilizerField.key]}
          label={<div dangerouslySetInnerHTML={{ __html: fertilizerField.name }}/>}
          decimalScale={2}
          withLabels
          suffix={` ${fertilizerField.unit}`}
          allowDecimals={true}
          placeholder={`in ${fertilizerField.unit}`}
          onChange={(value) => setFertlizerValues({ ...fertilizerValues, [fertilizerField.key]: value || '' })}
        />
      })}
    </div>
  }

  return <Dialog
    textHeader={fertilizerData?.label || ''}
    textClose={t('Cancel')}
    type='abort'
    style={{ width: 700 }}
    textSubmit={t('Adjust')}
    isDialogOpen={Boolean(fertilizerData)}
    handleClose={() => {
      setFertlizerValues(defaultValues)
      handleClose()
    }}
    handleSubmit={() => handleSubmitFertilizer()}
    textContent={renderFertilizerValues()}
  />
}
export default EditFertilizers